<template>
  <div class="n_businessList">
    <div class="n_cardList">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div
            class="n_card flex"
            v-for="(item,index) in list"
            :key="item.id"
            @click="jump(item.id)"
          >
            <img class="n_userActiv" :src="item.head_photo" alt />
            <div class="n_right">
              <div>
                <span class="n_name">{{item.user_name}}</span>
                <span class="n_tag">{{item.position}}</span>
              </div>
              <div class="n_company">{{item.company_name}}</div>
              <div class="flex alitem_center">
                <div class="n_message">
                  <div class="n_photo">
                    <span class="iconfont icondianhua3"></span>
                    <span class="n_phone">{{item.tel}}</span>
                  </div>
                  <div class="n_email">
                    <span class="iconfont iconyouxiang"></span>
                    <span class="n_phone">{{item.email}}</span>
                  </div>
                </div>
                <img class="n_diam" :src="imgPath + 'yj_iocns_d.png'" alt />
              </div>
            </div>
            <div class="n_number">NO.{{index + 1}}</div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      queryParam: { page: 0, limit: 10, user_name: '' },
      list: [], //名片
      refreshing: false,
    }
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    //获取名片列表
    async getList() {
      if (this.refreshing) {
        this.list = []
        this.queryParam.page = 0
        this.refreshing = false
      }
      let res = await this.http('BusCard.getMchCardList', this.queryParam)
      this.loading = false
      this.list = this.list.concat(res.content.list)
      this.finished = this.list.length == res.content.count
    },
    onLoad() {
      this.queryParam.page++
      // 加载状态结束
      this.getList()
    },
    onRefresh() {
      // 清空列表数据
      console.log('111')
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    jump(id) {
      console.log(id)
      this.$router.push({ path: '/social', query: { id: id } })
    },
  },
}
</script>

<style scoped lang="scss">
.n_diam {
  width: 32px;
  height: 10px;
}
.alitem_center {
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.iconG_diandian {
  font-size: 64px;
  color: #fff;
}
.n_message {
  color: rgba(209, 206, 194, 1);
}
.n_phone {
  font-size: 24px;
  margin-left: 8px;
}
.n_number {
  position: absolute;
  right: 22px;
  top: 11px;
  padding: 8px 16px;
  border-radius: 12px;
  border: 2px solid #ffedb3;
  font-size: 24px;
  color: #f4e3ac;
}
.n_card {
  position: relative;
  // width: 692px;
  height: 310px;
  padding: 38px 40px;
  box-sizing: border-box;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yj_blackbbg.png')
    no-repeat;
  background-size: contain;
  margin-bottom: 20px;
}
.n_card .n_userActiv {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: red;
}
.n_businessList {
  min-height: 100vh;
  background: rgba(249, 249, 249, 1);
  padding: 26px 30px;
  box-sizing: border-box;
}
.n_right {
  width: 100%;
  margin-left: 30px;
  flex: 1;
}
.n_company {
  padding: 20px 0;
  border-bottom: 1px solid #606060;
  color: rgba(255, 237, 179, 1);
  font-size: 24px;
  color: #ffedb3;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.n_name {
  font-size: 36px;
  color: #ffffff;
}
.n_tag {
  font-size: 24px;
  color: #ffedb3;
  margin-left: 10px;
}
</style>